import BookItem from "../common/bookItem";
import { mouseEvent } from "../common/mouse_event";
import VisibleSwitchLineChild from "./visible_switch_line_child";
export default class VisibleSwitchLine extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.connectNumber = this.el.connectNumber;

        this.lineGroup = [];
        mouseEvent.add_mouse_event(this);
    }

    //重點畫線done

    init() {
        this.target.gotoAndStop(0);
        this.itemControl.loader.singleAntialiasing(this.target);

        this.lineGroup = this.itemControl.getItemsByClassConnect("lineshowbtnchild", this);
    }

    trigger() {
        const self = this;

        // self.itemControl.bookItems.forEach(element => {
        //     if ((element instanceof VisibleSwitchLineChild) == true && element.connectNumber == self.connectNumber) {
        //         element.target.visible = !element.target.visible;
        //     }
        // });

        this.lineGroup.forEach(element => {
            element.target.visible = !element.target.visible;
        });
        this.isOpen = !this.isOpen; //反轉
    }
}